module.exports = __webpack_public_path__ + "static/media/aviato.0cc0ca14.svg";